export default __webpack_public_path__ + "static/media/LoginF.00b8e675.jpg";